import { z } from 'zod';

const FileSchema = z.object({
  id: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  filename: z.string(),
  filepath: z.string(),
  size: z.number(),
  created_by: z.number(),
  updated_by: z.number(),
});

const OrganizationSchema = z.object({
  id: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  code: z.string(),
  name: z.string(),
  company_id: z.number(),
  created_by: z.number(),
  updated_by: z.number(),
});

const CountrySchema = z.object({
  id: z.number(),
  name: z.string(),
});

const TariffBookItemSchema = z.object({
  id: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  starting_date: z.string(),
  status: z.string(),
  content_path: z.string(),
  company_id: z.number(),
  organization_id: z.number().nullable().optional(),
  file_id: z.number(),
  created_by: z.number(),
  updated_by: z.number(),
  organization_name: z.string().nullable().optional(),
  organization_code: z.string().optional(),
  activate_discount_rule: z.boolean().nullable().optional(),
  discount_rule: z.string().nullable().optional(),
  file: FileSchema.nullable().optional(),
  organization: OrganizationSchema.nullable().optional(),
  country: CountrySchema.nullable().optional(),
});

export const parseTariffBookList = (responseBody) => {
  const result = z.array(TariffBookItemSchema).safeParse(responseBody?.data);
  if (!result.success) {
    console.warn('[Schema] TariffBookList mismatch:', result.error.flatten());
    return responseBody;
  }
  return { ...responseBody, data: result.data };
};

export const parseTariffBookDetail = (responseBody) => {
  const result = TariffBookItemSchema.safeParse(responseBody?.data);
  if (!result.success) {
    console.warn('[Schema] TariffBookDetail mismatch:', result.error.flatten());
    return responseBody;
  }
  return { ...responseBody, data: result.data };
};

export const parseSuperAdminTariffBookList = parseTariffBookList;
export const parseSuperAdminTariffBookDetail = parseTariffBookDetail;
